export var SortingOptions;
(function (SortingOptions) {
    SortingOptions["OUR_PICKS"] = "Our picks";
    SortingOptions["UNIVERSITY_META_RANKING"] = "University Meta Ranking";
})(SortingOptions || (SortingOptions = {}));
